import { render, staticRenderFns } from "./rateIncomes.vue?vue&type=template&id=24edf6ce&"
import script from "./rateIncomes.vue?vue&type=script&lang=js&"
export * from "./rateIncomes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports